import Store, { actions } from '@store';

function addEditorFacadeListeners (EditorFacade) {
  EditorFacade.on('select', onSelect);

  function onSelect (elements) {
    Store.dispatch(actions.canvas.setSelectedElements(elements.filter(Boolean)));
  }
}

function configureDispatchers ({
  EditorFacade
}) {
  addEditorFacadeListeners(EditorFacade);
}

export default {
  configureDispatchers
};
